import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const Mail = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='Mail' {...props}>
    <path fill='#01A982' fillRule='evenodd' d='M23,20 L23,6 L12,15 L1,6 L1,20 L23,20 Z M12,12 L22,4 L2,4 L12,12 Z' />
  </StyledIcon>
);
